import "./infopage.css";

import Header from "../../components/header/Header";
import InfoNavbar from "../../components/infonavbar/InfoNavbar";


import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import parse from 'html-react-parser';

import Imagecontent from "../../components/imagecontent/Imagecontent";
import {linksConfig} from "../../linksConfig";

import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import {InteractionStatus} from "@azure/msal-browser";
import { BarLoader } from "react-spinners";


async function loadData(accessToken,setData,setElement,pathname,data) {
 if(data ==''){
  try {
    //console.log('token in infopage: '+accessToken);
    var headers = new Headers();
    var bearer = "Bearer "+accessToken;
    headers.append("Authorization",bearer);
    var options={method:"GET",headers:headers};
    // console.log(`${linksConfig.link.apilink}/info/`+pathname)
    await fetch(`${linksConfig.link.apilink}/info/`+pathname,options)
      .then((response) => response.json())
      .then((receiveData) => {
        setElement(parse(receiveData));
        return setData(receiveData);
      });
  } catch (error) {
    console.log(error);
  }
 }
}

function getPage(type,element,setData,setElement,accessToken,data) {


  type = decodeURI(type);
  type= type.split(".").join("/");
  switch (type) {
    case "Information Classification":
      loadData(accessToken,setData,setElement,"Info_Ic",data);
      return element;
    case "Workers Council Approval (BR)":
      loadData(accessToken,setData,setElement,"Info_Wca",data);
      return element;
    case "Data Processing on Behalf (DPoB/AVV)":
      loadData(accessToken,setData,setElement,"Info_Avv_dpob",data);
      return element;
    case "ITSCM":
      loadData(accessToken,setData,setElement,"Info_Itscm",data);
      return element;
    case "Business Continuity Management (BCM)":
      loadData(accessToken,setData,setElement,"Info_Bcm",data);
      return element;
    case "ISA - Request":
      loadData(accessToken,setData,setElement,"Info_Isa",data);
      return element;
    case "Security Profile":
      loadData(accessToken,setData,setElement,"Info_Sp",data);
      return element;
    case "Penetration Test":
      loadData(accessToken,setData,setElement,"Info_Pen",data);
      return element;
    case "Domain Management Tool Entry":
      loadData(accessToken,setData,setElement,"Info_Dmt",data);
      return element;
    case "LeanIX":
      loadData(accessToken,setData,setElement,"Info_LeanIX",data);
      return element;
    case "Data at Cloud 4 Daimler Truck (DaC4DT)":
      loadData(accessToken,setData,setElement,"Info_Dac",data);
      return element;
    case "Compliance Framework for Data Analytics (CFDA)":
      loadData(accessToken,setData,setElement,"Info_Cfda",data);
      return element;
    case "Records of Processing Activities (RoPA/VVT)":
      loadData(accessToken,setData,setElement,"Info_Vvt_ropa",data);
      return element;
    case "Data Protection Impact Assessment (DSFA/DPIA)":
      loadData(accessToken,setData,setElement,"Info_Dsfa_dpia",data);
      return element;
    case "Technical and organisational measures (TOM)":
      loadData(accessToken,setData,setElement,"Info_Tom",data);
      return element;
    case "Deletion Concept":
      loadData(accessToken,setData,setElement,"Info_Dc",data);
      return element;
    case "Develop / Test with Personal Data":
      loadData(accessToken,setData,setElement,"Info_Dev_test",data);
      return element;
    case "Integrated Code Audits":
      loadData(accessToken,setData,setElement,"Info_Ica",data);
      return element;
    case "MFA":
      loadData(accessToken,setData,setElement,"Info_Mfa",data);
      return element;
    case "Identity and Access Management (IAM)":
      loadData(accessToken,setData,setElement,"Info_Iam",data);
      return element;
    case "Application Security Requirements Guidelines (ASRG)":
      loadData(accessToken,setData,setElement,"Info_Asrg",data);
      return element;  
    case "ASRG  Level 1 (Basic)":
      loadData(accessToken,setData,setElement,"Info_Asrg1",data);
      return element;
    case "ASRG Level 2 (Intermediate)":
      loadData(accessToken,setData,setElement,"Info_Asrg2",data);
      return element;
    case "ASRG Level 3 (Advanced)":
      loadData(accessToken,setData,setElement,"Info_Asrg3",data);
      return element;
    case "Penetration Test ":
      loadData(accessToken,setData,setElement,"Info_Pentest",data);
      return element;
    case "SSL SCAN":
      loadData(accessToken,setData,setElement,"Info_Sslscan",data);
      return element;
    case "Operations Manual":
      loadData(accessToken,setData,setElement,"Info_Om",data);
      return element;
    case "Domain Management Tool - Removal":
      loadData(accessToken,setData,setElement,"Info_Dmt_rem",data);
      return element;
    case "LeanIX Removal":
      loadData(accessToken,setData,setElement,"Info_LeanIX_rem",data);
      return element;
    default:
      return (
        <div>
          <p>Page Not found!!</p>
        </div>
      );
  }
}

export default function Infopage() {
  
  const [data, setData] = useState([""]);
  const [element, setElement] = useState();

  const { type } = useParams();
  //authenticate 
const {instance,inProgress,accounts} = useMsal();
const isAuthenticated = useIsAuthenticated();
const request = { ...loginRequest,account: accounts[0]};
const [accessToken,setAccessToken] = useState("");
const [isLoading,setisLoading] = useState(true);

if(inProgress === InteractionStatus.None && !isAuthenticated){
  
    if(accounts.length === 0){
      setTimeout(() => {
      instance.loginRedirect(loginRequest).catch(e => { console.log(e);});
    }, 500);
    }
//  console.log('here')
}
else if(isAuthenticated){

 setTimeout(()=>{
  if(accessToken==""){
  //  console.log('user is authenticated!');
  instance.acquireTokenSilent(request).then((response) => {
    setAccessToken(response.accessToken);
}).then(()=>{setisLoading(false);})
.catch((e) => {
    instance.acquireTokenPopup(request).then((response) => {
        setAccessToken(response.accessToken);
    });
});
// console.log('requesting token: '+accessToken)
  }
 },1000)

 }

 useEffect(() => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
}, []);

  return (
    <div>
      <Header />
      <InfoNavbar />
      <Imagecontent title={type} />
      <br />
      <AuthenticatedTemplate>
        
      <div>{isLoading?<BarLoader className="info_loader"  color="#000000" width={200}/>:<div className="secnav__infopart"> {getPage(type,element,setData,setElement,accessToken,data)}</div>}</div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div>Please LoginIn to view Content!</div>
      </UnauthenticatedTemplate>
    </div>
  );
}
